import { MergeFieldDto } from '@rcp/types';
import { RestSlice } from 'src/redux/rest.slice';
import { localizationService, Resource } from 'src/services';

export const mergeFieldSlice = new RestSlice<MergeFieldDto>(
	localizationService.getLocalizedString('notices.mergeFields'),
	Resource.SettingNoticeTemplatesMergeFields
);
export default mergeFieldSlice.rests.reducer;
